<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M10.6 4C10.9314 4 11.2 4.26863 11.2 4.6C11.2 4.93137 10.9314 5.2 10.6 5.2H5.4C5.06863 5.2 4.8 4.93137 4.8 4.6C4.8 4.26863 5.06863 4 5.4 4H10.6Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9648 1.00391C13.6556 1.08969 15 2.48797 15 4.2V11.8L14.9961 11.9648C14.9131 13.601 13.601 14.9131 11.9648 14.9961L11.8 15H4.2L4.03516 14.9961C2.39904 14.9131 1.08692 13.601 1.00391 11.9648L1 11.8V4.2C1 2.48797 2.34445 1.08969 4.03516 1.00391L4.2 1H11.8L11.9648 1.00391ZM4.2 2.2C3.09543 2.2 2.2 3.09543 2.2 4.2V11.8C2.2 12.9046 3.09543 13.8 4.2 13.8H11.8C12.9046 13.8 13.8 12.9046 13.8 11.8V4.2C13.8 3.09543 12.9046 2.2 11.8 2.2H4.2Z"
            fill="currentColor"
        />
    </svg>
</template>
